<script>
    import V from 'voUtils/V.js'



    export default {
    	voVueComponent: 'not-found',


    	mounted: function() {

    		//setTimeout(window.location.href = "./", 15000);
    		setTimeout(function() {
    			window.location.href = "./"
    		}, 10000);
    	}
    };
</script>